import classNames from 'classnames';
import { ReactNode } from 'react';

import ControlErrors from '../typography/ControlErrors';
import ControlLabel from '../typography/ControlLabel';

import styles from '../../styles/forms/form-control.module.css';

interface FormControlProps {
    name?: string | null;
    label?: ReactNode | null;
    children?: ReactNode;
    disabled?: boolean;
    required?: boolean;
    errors?: string[] | null;
    withoutErrors?: boolean;
    className?: string | null;
    labelClassName?: string | null;
}

function FormControl({
    name = null,
    label = null,
    children = null,
    disabled = false,
    required = false,
    errors = null,
    withoutErrors = false,
    className = null,
    labelClassName = null,
}: FormControlProps) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.disabled]: disabled,
                    [styles.required]: required,
                },
                className,
            ])}
        >
            {label !== null ? (
                <ControlLabel
                    tag="label"
                    htmlFor={name ?? undefined}
                    className={classNames(styles.label, labelClassName)}
                >
                    {label}
                </ControlLabel>
            ) : null}
            {children}
            {errors !== null && !withoutErrors ? (
                <ControlErrors tag="div" className={styles.errors}>
                    <ul>
                        {(errors || []).map((error) => (
                            <li key={`error-${error}`}>{error}</li>
                        ))}
                    </ul>
                </ControlErrors>
            ) : null}
        </div>
    );
}

export default FormControl;
